import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/api";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[#071F42] text-white/90" data-testid="site-footer">
      <div className="container-site py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="inline-block bg-white rounded-2xl p-3 mb-5 shadow-[0_8px_24px_rgba(0,0,0,0.25)]">
            <img src={LOGO_URL} alt="Visit Bedford" className="h-20 w-auto block" />
          </div>
          <p className="font-serif-display text-2xl leading-snug mb-4 text-white">
            Your trusted independent guide to Bedford &amp; the new Universal Studios resort.
          </p>
          <p className="text-sm text-white/60 max-w-md leading-relaxed">
            We curate the best hotels, itineraries and experiences so your trip feels effortless — from the banks of the Great Ouse to the gates of the park.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs tracking-[0.25em] uppercase text-[#9FD8F0] mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/hotels" className="hover:text-white">Hotels Near Universal</Link></li>
            <li><Link to="/plan-your-trip" className="hover:text-white">Plan Your Trip</Link></li>
            <li><Link to="/things-to-do" className="hover:text-white">Things To Do</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog &amp; Guides</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs tracking-[0.25em] uppercase text-[#9FD8F0] mb-5">The Fine Print</h4>
          <p className="text-sm text-white/60 leading-relaxed mb-4">
            Visit Bedford is an independent travel resource and is not affiliated with Universal Studios, Comcast, or NBCUniversal.
            Some links are affiliate links — we may earn a small commission at no cost to you.
          </p>
          <Link to="/admin/login" className="text-xs text-white/40 hover:text-white" data-testid="footer-admin-link">
            Admin Login
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-site py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {year} Visit Bedford. All rights reserved.</span>
          <span>Made with care on the banks of the Great Ouse.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
